export type FragmentItemsFieldsFragment = {
	colorId: string
	customized: boolean
	itemId: string
	look?: string | null
	productId: string
	hasLowStock: boolean
	quantity: number
	seller: string
	sizeId: string
	outOfStock?: boolean | null
	warehouses?: Array<string | null> | null
	price: {
		discountRate?: number | null
		promotionName?: string | null
		star?: boolean | null
		type?: string | null
		current: { currentPrice: number }
		initial: { initialPrice: number }
		previous?: {
			lowest?: {
				promo?: { amount: number } | null
				sale?: { amount: number } | null
			} | null
			original?: {
				shop?: { amount: number } | null
				outlet?: { amount: number } | null
			} | null
		} | null
	}
	promotion?: {
		code?: string | null
		price?: { amount: number; currency: string; decimals: number } | null
	} | null
}

export type FragmentSummaryDtoFieldsFragment = {
	freeShipping: boolean
	promoteShippingToStore: boolean
	taxable: boolean
	deliveryCost: { deliveryAmount: number }
	subtotal: { subTotalPrice: number }
	total: { totalPrice: number }
	remainingCostToBeFreeShipping: { untilFree: number }
	saved: { amount: number }
	savedDetails?: {
		hasAnyItemPricePromotionalOrSale?: boolean | null
		saved?: { amount: number; currency: string; decimals: number } | null
	} | null
	original: { amount: number }
}

export type FragmentPromotionDtoFieldsFragment = {
	isApplied?: boolean | null
	code?: { name?: string | null; type?: string | null } | null
	discount?: { amount: number; currency: string; decimals: number } | null
	applyPromoCodeResult?: {
		hasFailed: boolean
		exception?: string | null
	} | null
}

export type FragmentLimitsFieldsFragment = {
	maxUnits: number
	maxAmount: { amount: number; currency: string; decimals: number }
}

export type FragmentInstallmentPaymentFragment = {
	installments: number
	minimumCLTV?: number | null
	installmentAmount?: {
		amount: number
		currency: string
		decimals: number
	} | null
	minimumAmount: { amount: number; currency: string; decimals: number }
}

export const FragmentItemsFieldsFragmentDoc = `
    fragment FragmentItemsFields on ItemDto {
  colorId
  customized
  itemId
  look
  price {
    current {
      currentPrice: amount
    }
    initial {
      initialPrice: amount
    }
    discountRate
    promotionName
    previous {
      lowest {
        promo {
          amount
        }
        sale {
          amount
        }
      }
      original {
        shop {
          amount
        }
        outlet {
          amount
        }
      }
    }
    star
    type
  }
  productId
  promotion {
    code
    price {
      amount
      currency
      decimals
    }
  }
  hasLowStock
  quantity
  seller
  sizeId
  outOfStock
  warehouses
}
    `
export const FragmentSummaryDtoFieldsFragmentDoc = `
    fragment FragmentSummaryDtoFields on SummaryDto {
  deliveryCost {
    deliveryAmount: amount
  }
  freeShipping
  promoteShippingToStore
  subtotal {
    subTotalPrice: amount
  }
  total {
    totalPrice: amount
  }
  remainingCostToBeFreeShipping {
    untilFree: amount
  }
  taxable
  saved {
    amount
  }
  savedDetails {
    hasAnyItemPricePromotionalOrSale
    saved {
      amount
      currency
      decimals
    }
  }
  original {
    amount
  }
}
    `
export const FragmentPromotionDtoFieldsFragmentDoc = `
    fragment FragmentPromotionDtoFields on ShoppingCartPromotion {
  code {
    name
    type
  }
  discount {
    amount
    currency
    decimals
  }
  isApplied
  applyPromoCodeResult {
    hasFailed
    exception
  }
}
    `
export const FragmentLimitsFieldsFragmentDoc = `
    fragment FragmentLimitsFields on Limits {
  maxAmount {
    amount
    currency
    decimals
  }
  maxUnits
}
    `
export const FragmentInstallmentPaymentFragmentDoc = `
    fragment FragmentInstallmentPayment on InstallmentPaymentDto {
  installmentAmount {
    amount
    currency
    decimals
  }
  installments
  minimumAmount {
    amount
    currency
    decimals
  }
  minimumCLTV
}
    `
